
import Api from '@/api'


const fetchAll = () => {	
    
    return Api.get('api/recipesteps')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") {        
        return Api.put('api/recipesteps/' + id , payload)       
    } else {
        return Api.post('api/recipesteps' , payload)       
    }    
};

const getById =  (payload) => {        
    return Api.get('api/recipesteps/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/recipesteps/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById,
  
};